import { Component } from '@angular/core';
import { ManagementPartTimeEmployee } from '../../models/models';
import { BaseEditFormComponent } from '../../../shared/base-edit-form/base-edit-form.component';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'tbody[lsz-part-time-employee-leadership-typed-form]',
  templateUrl: './part-time-employee-leadership-typed-form.component.html',
  styleUrls: ['./part-time-employee-leadership-typed-form.component.css'],
})
export class PartTimeEmployeeLeadershipTypedFormComponent extends BaseEditFormComponent<ManagementPartTimeEmployee> {

  public get personnelCount(): AbstractControl {
    return this.form.get('personnelCount');
  }

  constructor() {
    super();
  }

  public onClickSave(): void {
    this.entrySaved.emit({
      ...this.entry,
      personnelCount: this.personnelCount.value as number,
    } as ManagementPartTimeEmployee);
  }
}
